import type { MPLOffer, MPLPreApprovalOffer } from 'commonTypes/api/scenarios/CreditSelectionScreenContent';

import type { sendEventOnClickOfferOnMplCreditSelectionScreen } from 'shared/lib/sendGAEvents';
import type { TOffer } from 'shared/types/TRankingService';

import { getAnalyticsBadgesParam } from './getAnalyticsBadgesParam';
import { getAnalyticsProductParams } from './getAnalyticsProductParams';
import { getAnalyticsProductTypeParam } from './getAnalyticsProductTypeParam';
import { getAnalyticsSummariesParams } from './getAnalyticsSummariesParams';
import type { TCommonMplAnalyticsParams } from './getCommonMplAnalyticsParams';

export const getAnalyticsOnClickOfferData = (
  commonMplAnalyticsParams: TCommonMplAnalyticsParams,
  offer: TOffer | MPLOffer | MPLPreApprovalOffer,
  timeOnPageInSeconds: number,
): Parameters<typeof sendEventOnClickOfferOnMplCreditSelectionScreen>[0] => ({
  ...commonMplAnalyticsParams,
  ...getAnalyticsProductParams(offer),
  ...getAnalyticsSummariesParams(offer),
  badges: getAnalyticsBadgesParam(offer),
  productType: getAnalyticsProductTypeParam(offer),
  timeOnPage: timeOnPageInSeconds,
});
